<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingNotificationCenterList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="500"
            :footer-props="footerProps"
            class="product-table"
            dense
            :headers="tableHeaders"
            :items="notifications"
        >
            <template v-slot:item="{ item }">
                <tr
                    :key="'notification_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow: activeNotification && parseInt(item.id) === parseInt(activeNotification.id)
                    }"
                >
                    <td>{{ item.id ? item.id : "-" }}</td>
                    <td>{{ item.invoice_id ? item.invoice_id : "-" }}</td>
                    <td>{{ item.invoice_date ? item.invoice_date : "-" }}</td>
                    <td>{{ item.invoice_number ? item.invoice_number : "-" }}</td>
                    <td>{{ item.description ? item.description : "-" }}</td>
                    <td>{{ item.account_type ? item.account_type : "-" }}</td>
                    <td>{{ item.errors ? item.errors : "-" }}</td>
                    <td style="text-align: end;">{{ item.type ? item.type : "-" }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import Store from "../../store";

export default {
    name: "notification-center-list",
    components: {},
    data() {
        return {
            search: null,
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            tableHeaders: [
                {
                    text: this.t("Row ID"),
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Invoice ID"),
                    align: "left",
                    value: "invoice_id"
                },
                {
                    text: this.t("Invoice date"),
                    align: "left",
                    value: "invoice_date"
                },
                {
                    text: this.t("Invoice number"),
                    align: "left",
                    value: "invoice_number"
                },
                {
                    text: this.t("Description"),
                    align: "left",
                    value: "description"
                },
                {
                    text: this.t("Account type"),
                    align: "left",
                    value: "account_type"
                },
                {
                    text: this.t("Errors"),
                    align: "left",
                    value: "errors"
                },
                {
                    text: this.t("Type"),
                    align: "end",
                    value: "type"
                }
            ]
        };
    },
    async mounted() {
        if (this.drawerOpen) {
            document.documentElement.style.overflow = "hidden";
        }
        await Store.dispatch("NotificationCenterStore/getNotificationsList");
    },
    watch: {
        options(val) {
            Store.commit("ExportSaleInvoiceStore/setTableOptions", val);
        },
        drawerOpen() {
            if (this.drawerOpen) {
                document.documentElement.style.overflow = "hidden";
            } else {
                document.documentElement.style.overflow = "auto";
            }
        }
    },
    computed: {
        ...mapState("NotificationCenterStore", [
            "notifications",
            "loadingNotificationCenterList",
            "activeNotification",
            "drawerOpen"
        ])
    },
    methods: {
        async handleTableRowClick(notification) {
            await Store.commit("NotificationCenterStore/resetActiveNotificationData");
            if (this.$route.name !== "notification-center-view") {
                await this.$router.push({
                    name: "notification-center-view",
                    params: { notificationId: notification.id, notificationType: notification.type }
                });
                return;
            }
            if (
                this.$route.name === "notification-center-view" &&
                parseInt(notification.id) !== parseInt(this.$route.params.notificationId) &&
                notification.type !== this.$route.params.notificationType
            ) {
                await this.$router.push({
                    name: "notification-center-view",
                    params: { notificationId: notification.id, notificationType: notification.type }
                });
                const param = {
                    id: notification.id,
                    type: notification.type
                };
                await Store.dispatch("NotificationCenterStore/getNotificationData", param);
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

.preventscroll {
    overflow-y: scroll;
    width: 100%;
}

td {
    padding: 0px;
}

.v-row-group__summary {
    background-color: #b1b1b1 !important;
    height: 40px;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
